import {

    FETCH_COMMAND_HISTORY_PENDING,
    FETCH_COMMAND_HISTORY_FULFILLED,
    FETCH_COMMAND_HISTORY_REJECTED,

    DELETE_COMMAND_HISTORY_PENDING,
    DELETE_COMMAND_HISTORY_FULFILLED,
    DELETE_COMMAND_HISTORY_REJECTED,

    CHANGE_COMMAND_HISTORY

} from './commandHistoryActions'

const moment = require('moment');
const initialState = {
    loading: false,
    listOfCommandHistory: [],
    commandHistory: {
        veiculo: 0,
        dataInicial: moment().utc().format("DD/MM/YYYY"),
        horaInicial: '00:00:00',
        dataFinal: moment().utc().format("DD/MM/YYYY"),
        horaFinal: moment().format("HH:mm:ss")
    },
    error: null,
}

export function commandHistoryReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_COMMAND_HISTORY:
            return Object.assign({}, state, {
                commandHistory: {
                    ...state.commandHistory,
                    [action.payload.name]: action.payload.value
                }
            })
        case FETCH_COMMAND_HISTORY_PENDING:
            return Object.assign({}, state, {
                loading: true,
                listOfCommandHistory: [],
            })
        case FETCH_COMMAND_HISTORY_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                listOfCommandHistory: action.payload
            })
        case FETCH_COMMAND_HISTORY_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                listOfCommandHistory: [],
                error: action.payload
            })

        case DELETE_COMMAND_HISTORY_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case DELETE_COMMAND_HISTORY_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
            })
        case DELETE_COMMAND_HISTORY_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        default:
            return state
    }
}